import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Gauge } from 'lucide-react';
import { useT } from '../i18n';

/* Conversion band between homepage sections — dark, animated shine, double CTA. */
export default function MidCta() {
  const { lang } = useT();
  const es = lang === 'es';
  return (
    <section className="py-14 lg:py-16 bg-white" data-testid="mid-cta">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl bg-neutral-950 px-7 sm:px-12 py-10 lg:py-12"
        >
          <div aria-hidden="true" className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse 55% 80% at 80% 20%, rgba(247,127,17,0.22), transparent 65%)' }} />
          <motion.div aria-hidden="true"
            className="absolute inset-y-0 w-40 bg-gradient-to-r from-transparent via-white/[0.06] to-transparent -skew-x-12 pointer-events-none"
            animate={{ x: ['-30%', '1200%'] }} transition={{ duration: 5.5, repeat: Infinity, ease: 'linear', repeatDelay: 2 }} />
          <div className="relative flex flex-col lg:flex-row lg:items-center gap-7">
            <div className="flex-1">
              <p className="inline-flex items-center gap-2 text-[10.5px] tracking-[0.22em] uppercase font-bold text-[#FF9B4A]">
                <Gauge className="w-3.5 h-3.5" /> Restaurant Operating Score™
              </p>
              <h3 className="mt-3 text-2xl sm:text-[30px] font-bold text-white leading-tight tracking-[-0.01em] max-w-xl">
                {es ? '8 de cada 10 comensales eligen entre los 3 primeros resultados. ¿Estás ahí?' : '8 out of 10 diners choose from the top 3 results. Are you there?'}
              </h3>
              <p className="mt-2.5 text-[14.5px] text-neutral-400 max-w-lg">
                {es ? 'Escaneamos tu restaurante en vivo y te decimos exactamente dónde pierdes clientes — en 30 segundos, gratis.' : 'We scan your restaurant live and show exactly where you lose customers — in 30 seconds, free.'}
              </p>
            </div>
            <div className="flex flex-wrap gap-3 shrink-0">
              <Link to="/score" data-testid="mid-cta-score"
                className="inline-flex items-center gap-2 rounded-full bg-[#F77F11] hover:bg-[#d8651a] text-white h-12 px-7 text-[14.5px] font-bold shadow-lg shadow-orange-500/20 transition-all hover:scale-[1.03]">
                {es ? 'Ver mi Score gratis' : 'See my Score free'} <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/#audit" data-testid="mid-cta-audit"
                className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-white/60 text-white h-12 px-6 text-[14px] font-semibold transition-colors">
                {es ? 'Auditoría completa' : 'Full audit'}
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
